import { getDexConfig } from '@/utils/get-dex-config';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import { useState } from 'react';

const usePage = ({ title, breadcrumbs }) => {

	const { dex } = getEnvAndDex();
	const { dexName } = getDexConfig(dex);

	document.title = `${dexName} Admin - ${title}`

	const [breadcrumbsItems, setBreadcrumbsItems] = useState(breadcrumbs)

	return {
		breadcrumbsItems,
		setBreadcrumbsItems,
	}
}

export default usePage
